module.exports = __webpack_public_path__ + "logo_akademie.ad6f7f17.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/logo_akademie.jpg
 ** module id = 247
 ** module chunks = 0
 **/